import { ChangeDetectionStrategy, Component, Input, output } from '@angular/core';

@Component({
  selector: 'spa-alert',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AlertComponent {
  @Input() title = '';
  @Input() content = '';
  @Input() button: AlertComponentButtonConfig | undefined;

  readonly closed = output<void>();
}

export interface AlertComponentButtonConfig {
  label: string;
  action: (e: unknown) => void;
}
